const deepReset = (object) => {
  if (typeof object !== "object" || object === null) {
    return object; // Base case: return primitive values or null unchanged
  }

  if (Array.isArray(object)) {
    return object.map((element) => deepReset(element)); // Recursively copy array elements
  }

  // Recursively copy object properties
  const copiedObject = {};
  for (const key in object) {
    copiedObject[key] = deepReset(object[key]);
  }
  return copiedObject;
};

export default deepReset;
